module.exports = __webpack_public_path__ + "img/pagebanner-guide.ce29d0d5.jpg";